<template>
  <div class="guide">
    <div class="guide_tips">
      <a href="tel:400-0512-944">联系商机领航客服</a>
    </div>
    <div>
      <div class="guide_left">
        <div>微信扫码咨询客服</div>
        <div>实时了解<span>运营猫商机领航</span>最新信息</div>
        <div @click="$openHelp">点击在线沟通</div>
      </div>
      <div class="guide_right">
        <img src="@/assets/images/account/guide.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.guide {
  margin-top: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  > div:nth-child(1) {
    display: flex;
    justify-content: center;
    background-color: #fff;
    margin: 10px 0;
    a {
      font-size: 10px;
      color: var(--color_text);
      text-decoration: none;
    }
  }
  > div:nth-child(2) {
    padding: 10px 0;
    display: flex;
    background-color: rgba(200, 200, 200, 0.1);
    justify-content: space-between;
    border-radius: 10px;
    padding: 10px 20px;
    .guide_left {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      > div:nth-child(1) {
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        color: var(--color_basic);
      }
      > div:nth-child(2) {
        text-align: center;
        font-size: 10px;
        margin: 10px 0;
        color: var(--color_mainText);
        > span {
          font-weight: 600;
          margin: 0 3px;
          color: var(--color_basic);
          font-size: 12px;
        }
      }
      > div:nth-child(3) {
        border-radius: 10px;
        padding: 5px 15px;
        background-color: var(--color_basic);
        font-weight: 600;
        color: #fff;
        font-size: 10px;
      }
    }
    .guide_right {
      height: 110px;
      width: 110px;
      img {
        height: 110px;
        width: 110px;
        border-radius: 10px;
      }
    }
  }
}
</style>
